/**
 * MarineMax Shopify data layer helpers (GTM reads window.dataLayer).
 * Event names and snake_case parameters follow the MarineMax implementation guide.
 */
(function () {
  "use strict";

  var MM_LAST_RESULTS_URL_KEY = "mm_last_results_url";
  var MM_LAST_RESULTS_LABEL_KEY = "mm_last_results_label";

  function push(payload) {
    if (!payload || typeof payload !== "object") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function omitUndefined(obj) {
    var out = {};
    for (var k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
      if (obj[k] === undefined) continue;
      out[k] = obj[k];
    }
    return out;
  }

  function buildLeadPayload(eventName, ctx) {
    ctx = ctx || {};
    return omitUndefined({
      event: eventName,
      form_name: ctx.form_name || "contact_form",
      form_id: ctx.form_id != null ? String(ctx.form_id) : null,
      page_location:
        typeof window !== "undefined" && window.location
          ? window.location.href
          : null,
      item_name: ctx.item_name || null,
      item_id: ctx.item_id != null ? String(ctx.item_id) : null,
      store_location: ctx.store_location || null,
      lead_type: ctx.lead_type || null,
      value: typeof ctx.value === "number" ? ctx.value : null,
      currency: ctx.currency || "USD",
    });
  }

  function pushSelectItemFromCard(anchor) {
    var card = anchor.closest(".product-card[data-mm-item-id]");
    if (!card) return;
    var id = card.getAttribute("data-mm-item-id");
    var name = card.getAttribute("data-mm-item-name") || "";
    var listName = card.getAttribute("data-mm-item-list-name") || "";
    if (!id) return;
    push({
      event: "select_item",
      item_list_name: listName || null,
      ecommerce: {
        currency: "USD",
        items: [
          omitUndefined({
            item_id: String(id),
            item_name: name || null,
            item_brand: card.getAttribute("data-mm-item-brand") || null,
            price: (function () {
              var p = card.getAttribute("data-mm-item-price");
              if (p == null || p === "") return null;
              var n = parseFloat(p);
              return Number.isFinite(n) ? n : null;
            })(),
          }),
        ],
      },
    });
  }

  function initProductCardSelectItem() {
    document.addEventListener(
      "click",
      function (e) {
        var a = e.target.closest("a[href]");
        if (!a) return;
        var href = a.getAttribute("href") || "";
        if (href.indexOf("/products/") === -1) return;
        if (a.closest(".product-card__vendor, .product-card__type")) return;
        if (!a.closest(".product-card[data-mm-item-id]")) return;
        pushSelectItemFromCard(a);
      },
      true,
    );
  }

  function isResultsContextPage() {
    var path =
      typeof window !== "undefined" && window.location
        ? window.location.pathname || ""
        : "";
    if (path === "/search" || path.indexOf("/collections/") === 0) return true;
    if (document.getElementById("coveo-headless-search")) return true;
    if (document.getElementById("coveo-headless-collection")) return true;
    return false;
  }

  function storeLastResultsContext(anchor) {
    if (!anchor || !isResultsContextPage()) return;
    if (
      anchor.closest(".predictive-search, .header__predictive-search, .search-drawer")
    ) {
      return;
    }
    if (
      !anchor.closest(
        ".product-card, .coveo-search-card, .coveo-boat-card, .coveo-search-card-wrapper, .card",
      )
    ) {
      return;
    }
    try {
      var pageUrl = new URL(window.location.href);
      pageUrl.hash = "";
      sessionStorage.setItem(MM_LAST_RESULTS_URL_KEY, pageUrl.toString());
      sessionStorage.setItem(MM_LAST_RESULTS_LABEL_KEY, "Back to all results");
    } catch (_) {}
  }

  function clearLastResultsContext() {
    try {
      sessionStorage.removeItem(MM_LAST_RESULTS_URL_KEY);
      sessionStorage.removeItem(MM_LAST_RESULTS_LABEL_KEY);
    } catch (_) {}
  }

  function initLastResultsContextTracking() {
    document.addEventListener(
      "click",
      function (e) {
        var a = e.target.closest("a[href]");
        if (!a) return;
        var href = a.getAttribute("href") || "";
        if (href.indexOf("/products/") === -1) return;
        if (isResultsContextPage()) {
          storeLastResultsContext(a);
        } else {
          clearLastResultsContext();
        }
      },
      true,
    );
  }

  function initPdpBackToResultsLink() {
    var link = document.querySelector("[data-mm-back-results-link]");
    if (!link) return;
    try {
      var storedHref = sessionStorage.getItem(MM_LAST_RESULTS_URL_KEY) || "";
      var storedLabel = sessionStorage.getItem(MM_LAST_RESULTS_LABEL_KEY) || "";
      if (!storedHref) return;
      var parsed = new URL(storedHref, window.location.origin);
      if (parsed.origin !== window.location.origin) return;
      if (parsed.pathname.indexOf("/products/") === 0) return;
      link.setAttribute("href", parsed.pathname + parsed.search + parsed.hash);
      link.textContent = storedLabel || "Back to all results";
    } catch (_) {}
  }

  function pushGenerateLead(ctx) {
    push(buildLeadPayload("generate_lead", ctx));
  }

  function pushFormSubmit(ctx) {
    push(buildLeadPayload("form_submit", ctx));
  }

  function pushChatInteraction(ctx) {
    ctx = ctx || {};
    push(
      omitUndefined({
        event: "chat_interaction",
        chat_tool: ctx.chat_tool || null,
        action: ctx.action || null,
        prompt_label: ctx.prompt_label || null,
        prompt_type: ctx.prompt_type || null,
        page_location:
          typeof window !== "undefined" && window.location
            ? window.location.href
            : null,
      }),
    );
  }

  function initHubspotFormMessageListener() {
    window.addEventListener("message", function (event) {
      var d = event.data;
      if (
        !d ||
        d.type !== "hsFormCallback" ||
        d.eventName !== "onFormSubmitted"
      )
        return;
      pushFormSubmit({
        form_name: "request_info",
        form_id: d.id != null ? String(d.id) : null,
        lead_type: "sales",
        value: 100,
      });
      pushGenerateLead({
        form_name: "request_info",
        form_id: d.id != null ? String(d.id) : null,
        lead_type: "sales",
        value: 100,
      });
    });
  }

  function initAuthSessionMarkers() {
    var loginForm = document.querySelector("form.mm-account-login-form");
    if (loginForm) {
      loginForm.addEventListener("submit", function () {
        try {
          sessionStorage.setItem("mm_expect_login", "1");
        } catch (_) {}
      });
    }
    var regForm = document.querySelector("form.mm-account-register-form");
    if (regForm) {
      regForm.addEventListener("submit", function () {
        try {
          sessionStorage.setItem("mm_expect_sign_up", "1");
        } catch (_) {}
      });
    }
  }

  function consumeAuthDataLayer() {
    if (!document.querySelector("[data-mm-account-dashboard]")) return;
    try {
      if (sessionStorage.getItem("mm_expect_login") === "1") {
        sessionStorage.removeItem("mm_expect_login");
        push({ event: "login" });
      }
      if (sessionStorage.getItem("mm_expect_sign_up") === "1") {
        sessionStorage.removeItem("mm_expect_sign_up");
        push({ event: "sign_up" });
      }
    } catch (_) {}
  }

  function initAiChatWidgetObserver() {
    var w = document.querySelector(".ai-chat-widget");
    if (!w || w.dataset.mmChatDlObserved === "1") return;
    w.dataset.mmChatDlObserved = "1";
    var prev = w.classList.contains("chat-open");
    try {
      var obs = new MutationObserver(function () {
        var open = w.classList.contains("chat-open");
        if (open === prev) return;
        prev = open;
        pushChatInteraction({
          chat_tool: "boatchat",
          action: open ? "opened" : "closed",
        });
      });
      obs.observe(w, { attributes: true, attributeFilter: ["class"] });
    } catch (_) {}
  }

  function initIntercomHooks() {
    var tries = 0;
    function poll() {
      tries++;
      if (typeof window.Intercom !== "function") {
        if (tries < 40) setTimeout(poll, 500);
        return;
      }
      try {
        window.Intercom("onShow", function () {
          pushChatInteraction({
            chat_tool: "intercom",
            action: "opened",
          });
        });
        window.Intercom("onHide", function () {
          pushChatInteraction({
            chat_tool: "intercom",
            action: "closed",
          });
        });
      } catch (_) {}
    }
    poll();
  }

  window.MarineMaxDataLayer = {
    push: push,
    pushGenerateLead: pushGenerateLead,
    pushFormSubmit: pushFormSubmit,
    pushChatInteraction: pushChatInteraction,
    /** Coveo / inventory: filter_applied */
    pushFilterApplied: function (filterType, filterValue, searchTerm) {
      push(
        omitUndefined({
          event: "filter_applied",
          filter_type: filterType,
          filter_value: filterValue != null ? String(filterValue) : "",
          search_term: searchTerm || null,
        }),
      );
    },
    /** Saved search (call from future save-search UI). */
    pushSaveSearch: function (searchTerm, filtersApplied) {
      push(
        omitUndefined({
          event: "save_search",
          search_term: searchTerm || null,
          filters_applied: filtersApplied || null,
        }),
      );
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initProductCardSelectItem();
      initLastResultsContextTracking();
      initPdpBackToResultsLink();
      initHubspotFormMessageListener();
      initAuthSessionMarkers();
      if (document.querySelector("[data-mm-account-dashboard]")) {
        consumeAuthDataLayer();
      }
      initAiChatWidgetObserver();
      initIntercomHooks();
    });
  } else {
    initProductCardSelectItem();
    initLastResultsContextTracking();
    initPdpBackToResultsLink();
    initHubspotFormMessageListener();
    initAuthSessionMarkers();
    if (document.querySelector("[data-mm-account-dashboard]")) {
      consumeAuthDataLayer();
    }
    initAiChatWidgetObserver();
    initIntercomHooks();
  }
})();
